export const testimonials = [
  {
    quoteKey: "testimonials.ana_quote",
    authorKey: "testimonials.ana_author",
    roleKey: "testimonials.ana_role",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Ana&backgroundColor=b6e3f4"
  },
  {
    quoteKey: "testimonials.marko_quote",
    authorKey: "testimonials.marko_author",
    roleKey: "testimonials.marko_role",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Marko&backgroundColor=c0aede"
  },
  {
    quoteKey: "testimonials.jelena_quote",
    authorKey: "testimonials.jelena_author",
    roleKey: "testimonials.jelena_role",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Jelena&backgroundColor=d1d4f9"
  },
  {
    quoteKey: "testimonials.luka_quote",
    authorKey: "testimonials.luka_author",
    roleKey: "testimonials.luka_role",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=Luka&backgroundColor=b6e3f4"
  }
];